module.exports = __webpack_public_path__ + "img/solar_cup-bold.032727f7.svg";